<template>
    <div>
        <AppBreadCrumb :paths="[{ title: 'Fatura Yönetimi', path: '/billing' }, { title: 'Planlar' }]" :select="true" />
        <CustomerPlans :is-admin="false" :type="type" @go-back="goBack" />
    </div>
</template>
<script>
import AppBreadCrumb from "../../../components/common/AppBreadCrumb";
import CustomerPlans from "./components/CustomerPlans.vue";

export default {
    name: "BillingPlans",
    components: {
        CustomerPlans,
        AppBreadCrumb,
    },
    data: () => {
        return {
            type: null,
        };
    },
    mounted() {
        this.type = this.$route.params.type;
    },
    methods: {
        goBack() {
            this.$router.push({
                path: `/billing`,
            });
        },
    },
};
</script>
